import { useMemo } from 'react';
import { Snapshot, useRecoilValue } from 'recoil';
import { Patient } from '~/domain/patient/patient';
import {
    patientRepositoryState,
    selectedPatientIdState,
} from '~/state/atoms/patientAtoms';

export default function useSelectedPatient(): Patient | undefined {
    const patientRepository = useRecoilValue(patientRepositoryState);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);

    return useMemo(
        () =>
            selectedPatientId === null
                ? undefined
                : (patientRepository.getByPatientId(selectedPatientId) ??
                  undefined),
        [patientRepository, selectedPatientId]
    );
}

/**
 * The selected patient as `snapshot` holds it, looked up in the patient
 * repository by its DICOM Patient ID. Null when no patient is selected or
 * the repository no longer holds it.
 */
export function readSelectedPatient(snapshot: Snapshot): Patient | null {
    const patientId = snapshot.getLoadable(selectedPatientIdState).getValue();
    return patientId === null
        ? null
        : snapshot
              .getLoadable(patientRepositoryState)
              .getValue()
              .getByPatientId(patientId);
}
